/**
 * The aria-describedby value of a form field: the caller's own description ids first, then the ids of the messages
 * that are shown under the field (WCAG 1.3.1, 3.3.1). Undefined when there is nothing to point to.
 */
export const describedBy = (...ids: (string | false | undefined)[]) => ids.filter(Boolean).join(' ') || undefined;
